
webpack.register(
    'components/leaderboard/scorecard/scorecard',
    function() {
        return require('components/leaderboard/scorecard/scorecard');
    },
    false
);
webpack.register(
    'components/leaderboard/statistics/statistics',
    function() {
        return require('components/leaderboard/statistics/statistics');
    },
    false
);
webpack.register(
    'components/leaderboard/shot-by-shot/shot-by-shot',
    function() {
        return require('components/leaderboard/shot-by-shot/shot-by-shot');
    },
    false
);
webpack.register(
    'components/round-switcher/round-switcher',
    function() {
        return require('components/round-switcher/round-switcher');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/leaderboard/scorecard/scorecard'/>\r\n<can-import from='components/leaderboard/statistics/statistics'/>\r\n<can-import from='components/leaderboard/shot-by-shot/shot-by-shot'/>\r\n<can-import from='components/round-switcher/round-switcher'/>\r\n{{#if playerInfo.roundsInfo }}\r\n    <div class=\"c-shots-and-stats\">\r\n        <div class=\"s-scorecard-head\">\r\n            <div class=\"s-scorecard-head__title\">\r\n                Shots and Stats\r\n            </div>\r\n            <round-switcher {rounds-info}=\"playerInfo.roundsInfo\" {^round}=\"round\"/></round-switcher>\r\n        </div>\r\n\r\n        <div class=\"s-scorecard-content\">\r\n            <leaderboard-scorecard {round}=\"round\" {rounds-info}=\"playerInfo.roundsInfo\" {player}=\"player\"></leaderboard-scorecard>\r\n        </div>\r\n\r\n        <div class=\"s-statistics s-statistics--shot-and-stats\">\r\n            <!--STATISTICS-->\r\n            <leader-board-statistics {round}=\"round\" {player-info}=\"playerInfo\" {show-full-stats}=\"showFullStats\"></leader-board-statistics>\r\n        </div>\r\n        {{#if round}}\r\n            <div class=\"s-shot-by-shot\">\r\n                <leaderboard-shot-by-shot {round}=\"round\" {rounds-info}=\"playerInfo.roundsInfo\" {player-id}=\"player.identifier\" layout-type=\"pl\"></leaderboard-shot-by-shot>\r\n            </div>\r\n        {{/if}}\r\n    </div>\r\n{{else}}\r\n    {{#unless initialLoad}}\r\n        <div>No data for display</div>\r\n    {{/unless}}\r\n{{/if}}\r\n");